import React from 'react';
import { PlusIcon } from '@radix-ui/react-icons';

import styles from './floating-action-button.module.scss';
type FloatingActionButtonProps = {
  onClick?: () => void;
};

export const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ onClick }) => (
  <button className={styles['button']} onClick={onClick}>
    <PlusIcon />
  </button>
);
